import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import Utils from "../../../../../../utils/Utils";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import CheckBox from "../../../../../../components/checkbox/CheckBox";

class FattoriRischio extends Component {
    state = {
        fattoriRischio: {
            acqua: "",
            fruttiMare: "",
            mitili: "",
            vongole: "",
            fasolari: "",
            datteri: "",
            cannolicchi: "",
            capesante: "",
            ostriche: "",
            tartufi: "",
            telline: "",
            altroFruttoMare: "",
            altraFruttoMareTesto: "",
            fruttaNonLavata: "",
            altraFrutta: "",
            fruttiBosco: "",
            fragole: "",
            mirtilli: "",
            lamponi: "",
            ribes: "",
            misti: "",
            altraFruttiBosco: "",
            altraFruttoBoscoTesto: "",
            verduraNonLavata: "",
            verduraSpecifica: "",
            carneMaiale: "",
            insaccati: "",
            salsicceMaiale: "",
            carneCinghiale: "",
            salsicceCinghiale: "",
            selvaggina: "",
            selvagginaSpecifica: "",
            carneAltroAnimale: "",
            altroAnimaleSpecifico: "",
            frattaglie: ""
        },

    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
    }

    componentDidMount() {

        let newState = this.state.fattoriRischio;
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.fattoriRischio) {
            let fattoriRischioCopia = this.props.segnalazioneCopia.schedaSpeciale.fattoriRischio;
            newState.acqua = fattoriRischioCopia.acqua ? fattoriRischioCopia.acqua : "";
            newState.fruttiMare = fattoriRischioCopia.fruttiMare ? fattoriRischioCopia.fruttiMare : "";
            newState.mitili = fattoriRischioCopia.mitili ? fattoriRischioCopia.mitili : "";
            newState.vongole = fattoriRischioCopia.vongole ? fattoriRischioCopia.vongole : "";
            newState.fasolari = fattoriRischioCopia.fasolari ? fattoriRischioCopia.fasolari : "";
            newState.datteri = fattoriRischioCopia.datteri ? fattoriRischioCopia.datteri : "";
            newState.cannolicchi = fattoriRischioCopia.cannolicchi ? fattoriRischioCopia.cannolicchi : "";
            newState.capesante = fattoriRischioCopia.capesante ? fattoriRischioCopia.capesante : "";
            newState.ostriche = fattoriRischioCopia.ostriche ? fattoriRischioCopia.ostriche : "";
            newState.tartufi = fattoriRischioCopia.tartufi ? fattoriRischioCopia.tartufi : "";
            newState.telline = fattoriRischioCopia.telline ? fattoriRischioCopia.telline : "";
            newState.altroFruttoMare = fattoriRischioCopia.altroFruttoMare ? fattoriRischioCopia.altroFruttoMare : "";
            newState.altraFruttoMareTesto = fattoriRischioCopia.altraFruttoMareTesto ? fattoriRischioCopia.altraFruttoMareTesto : "";
            newState.fruttaNonLavata = fattoriRischioCopia.fruttaNonLavata ? fattoriRischioCopia.fruttaNonLavata : "";
            newState.altraFrutta = fattoriRischioCopia.altraFrutta ? fattoriRischioCopia.altraFrutta : "";
            newState.fruttiBosco = fattoriRischioCopia.fruttiBosco ? fattoriRischioCopia.fruttiBosco : "";
            newState.fragole = fattoriRischioCopia.fragole ? fattoriRischioCopia.fragole : "";
            newState.mirtilli = fattoriRischioCopia.mirtilli ? fattoriRischioCopia.mirtilli : "";
            newState.lamponi = fattoriRischioCopia.lamponi ? fattoriRischioCopia.lamponi : "";
            newState.ribes = fattoriRischioCopia.ribes ? fattoriRischioCopia.ribes : "";
            newState.misti = fattoriRischioCopia.misti ? fattoriRischioCopia.misti : "";
            newState.altraFruttiBosco = fattoriRischioCopia.altraFruttiBosco ? fattoriRischioCopia.altraFruttiBosco : "";
            newState.altraFruttoBoscoTesto = fattoriRischioCopia.altraFruttoBoscoTesto ? fattoriRischioCopia.altraFruttoBoscoTesto : "";
            newState.verduraNonLavata = fattoriRischioCopia.verduraNonLavata ? fattoriRischioCopia.verduraNonLavata : "";
            newState.verduraSpecifica = fattoriRischioCopia.verduraSpecifica ? fattoriRischioCopia.verduraSpecifica : "";
            newState.carneMaiale = fattoriRischioCopia.carneMaiale ? fattoriRischioCopia.carneMaiale : "";
            newState.insaccati = fattoriRischioCopia.insaccati ? fattoriRischioCopia.insaccati : "";
            newState.salsicceMaiale = fattoriRischioCopia.salsicceMaiale ? fattoriRischioCopia.salsicceMaiale : "";
            newState.carneCinghiale = fattoriRischioCopia.carneCinghiale ? fattoriRischioCopia.carneCinghiale : "";
            newState.salsicceCinghiale = fattoriRischioCopia.salsicceCinghiale ? fattoriRischioCopia.salsicceCinghiale : "";
            newState.selvaggina = fattoriRischioCopia.selvaggina ? fattoriRischioCopia.selvaggina : "";
            newState.selvagginaSpecifica = fattoriRischioCopia.selvagginaSpecifica ? fattoriRischioCopia.selvagginaSpecifica : "";
            newState.carneAltroAnimale = fattoriRischioCopia.carneAltroAnimale ? fattoriRischioCopia.carneAltroAnimale : "";
            newState.altroAnimaleSpecifico = fattoriRischioCopia.altroAnimaleSpecifico ? fattoriRischioCopia.altroAnimaleSpecifico : "";
            newState.frattaglie = fattoriRischioCopia.frattaglie ? fattoriRischioCopia.frattaglie : "";

            this.setState({fattoriRischio: newState});
        }
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.fattoriRischio}, "corretto"))
        this.props.setStatePadre(newState, "fattoriRischio", objectForBackend);
    }

    riceviValoreInput(field, event) {
        let newState = this.state.fattoriRischio;
        if (field && field.target && field.target.id) {
            newState[field.target.id] = field.target.value;
        } else {
            newState[field] = event.target.value;
        }
        let newStatePulito = this.pulisciValori(newState);
        this.setState({fattoriRischio: newStatePulito})
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.fattoriRischio}, "corretto"))
        this.props.setStatePadre(newStatePulito, "fattoriRischio", objectForBackend)
    }

    pulisciValori(state) {
        let newState = state;
        if (newState.fruttiMare !== "01") {
            newState.mitili = "";
            newState.vongole = "";
            newState.fasolari = "";
            newState.datteri = "";
            newState.cannolicchi = "";
            newState.capesante = "";
            newState.ostriche = "";
            newState.tartufi = "";
            newState.telline = "";
            newState.altroFruttoMare = "";
            newState.altraFruttoMareTesto = "";
        }
        if (newState.fruttaNonLavata !== "01") {
            newState.altraFrutta = "";
        }
        if (newState.fruttiBosco !== "01") {
            newState.fragole = "";
            newState.mirtilli = "";
            newState.lamponi = "";
            newState.ribes = "";
            newState.misti = "";
            newState.altraFruttiBosco = "";
            newState.altraFruttoBoscoTesto = "";
        }
        if (newState.verduraNonLavata !== "01") {
            newState.verduraSpecifica = "";
        }
        if (newState.selvaggina !== "01") {
            newState.selvagginaSpecifica = "";
        }
        if (newState.carneAltroAnimale !== "01") {
            newState.altroAnimaleSpecifico = "";
        }
        return newState
    }


    render() {
        const {t} = this.props
        return (
            <div>
                <div style={{marginTop: "10px"}}/>
                <div><h6>Fattori di rischio alimentari (nei 2 mesi precedenti la malattia)</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div>
                        <div className={"row"}>
                            <div className={"col-lg-4"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.FattoriRischio.acqua")}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"acquaSi"}
                                             name={"acqua"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.fattoriRischio.acqua === "01"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"acquaNo"}
                                             name={"acqua"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.fattoriRischio.acqua === "02"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"acquaNonSo"}
                                             name={"acqua"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.fattoriRischio.acqua === "03"}
                                />
                            </div>
                        </div>
                        <div className={"row"} style={{alignItems: "center"}}>
                            <div className={"col-lg-4"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.FattoriRischio.fruttiMare")}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"fruttiMareSi"}
                                             name={"fruttiMare"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.fattoriRischio.fruttiMare === "01"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"fruttiMareNo"}
                                             name={"fruttiMare"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.fattoriRischio.fruttiMare === "02"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"fruttiMareNonSo"}
                                             name={"fruttiMare"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.fattoriRischio.fruttiMare === "03"}
                                />
                            </div>
                        </div>
                        <fieldset disabled={this.state.fattoriRischio.fruttiMare !== "01"}>
                            <div className={"row"} style={{alignItems: "center"}}>
                                <div className={"col-lg-4"}>
                                    <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "1.5rem"}}>
                                        {t("SchedaSpecialeEpatiteE.FattoriRischio.quali")}
                                    </p>
                                </div>
                            </div>
                            <div style={{marginLeft: "2rem"}}>
                                <div className={"row"} style={{alignItems: "center"}}>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"mitili"}
                                                  checked={this.state.fattoriRischio.mitili === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.mitili")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"vongole"}
                                                  checked={this.state.fattoriRischio.vongole === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.vongole")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"fasolari"}
                                                  checked={this.state.fattoriRischio.fasolari === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.fasolari")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"datteri"}
                                                  checked={this.state.fattoriRischio.datteri === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.datteri")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"cannolicchi"}
                                                  checked={this.state.fattoriRischio.cannolicchi === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.cannolicchi")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                </div>
                                <div className={"row"} style={{alignItems: "center"}}>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"capesante"}
                                                  checked={this.state.fattoriRischio.capesante === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.capesante")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"ostriche"}
                                                  checked={this.state.fattoriRischio.ostriche === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.ostriche")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"tartufi"}
                                                  checked={this.state.fattoriRischio.tartufi === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.tartufi")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"telline"}
                                                  checked={this.state.fattoriRischio.telline === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.telline")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-1"}>
                                        <CheckBox id={"altroFruttoMare"}
                                                  checked={this.state.fattoriRischio.altroFruttoMare === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.altroFruttoMare")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                        <Input
                                            type={"textarea"}
                                            id={"altraFruttoMareTesto"}
                                            onChange={this.riceviValoreInput}
                                            field={"altraFruttoMareTesto"}
                                            value={this.state.fattoriRischio.altraFruttoMareTesto}
                                            placeholder={"Altro frutto di mare"}
                                            style={{display: this.state.fattoriRischio.altroFruttoMare === "true" ? "" : "none"}}
                                        />
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <div className={"row"} style={{alignItems: "center"}}>
                            <div className={"col-lg-7"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.FattoriRischio.fruttaNonLavata")}
                                </p>
                                <div className={"row"} style={{alignItems: "center"}}>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"fruttaNonLavataSi"}
                                                     name={"fruttaNonLavata"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.fattoriRischio.fruttaNonLavata === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"fruttaNonLavataNo"}
                                                     name={"fruttaNonLavata"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.fattoriRischio.fruttaNonLavata === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"fruttaNonLavataNonSo"}
                                                     name={"fruttaNonLavata"}
                                                     label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.fattoriRischio.fruttaNonLavata === "03"}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.FattoriRischio.specificare")}
                                </p>
                                <Input
                                    type={"textarea"}
                                    id={"altraFrutta"}
                                    onChange={this.riceviValoreInput}
                                    field={"altraFrutta"}
                                    value={this.state.fattoriRischio.altraFrutta}
                                    disabled={this.state.fattoriRischio.fruttaNonLavata !== "01"}
                                    placeholder={"Frutta"}
                                />
                            </div>
                        </div>

                        <div className={"row"} style={{alignItems: "center"}}>
                            <div className={"col-lg-4"}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.FattoriRischio.fruttiBosco")}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"fruttiBoscoSi"}
                                             name={"fruttiBosco"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                             value={"01"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.fattoriRischio.fruttiBosco === "01"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"fruttiBoscoNo"}
                                             name={"fruttiBosco"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                             value={"02"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.fattoriRischio.fruttiBosco === "02"}
                                />
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"fruttiBoscoNonSo"}
                                             name={"fruttiBosco"}
                                             label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                             value={"03"}
                                             newRadio={true}
                                             onClick={this.riceviValoreInput}
                                             checked={this.state.fattoriRischio.fruttiBosco === "03"}
                                />
                            </div>
                        </div>
                        <fieldset disabled={this.state.fattoriRischio.fruttiBosco !== "01"}>
                            <div className={"row"} style={{alignItems: "center"}}>
                                <div className={"col-lg-4"}>
                                    <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "1.5rem"}}>
                                        {t("SchedaSpecialeEpatiteE.FattoriRischio.quali")}
                                    </p>
                                </div>
                            </div>
                            <div style={{marginLeft: "2rem"}}>
                                <div className={"row"} style={{alignItems: "center"}}>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"fragole"}
                                                  checked={this.state.fattoriRischio.fragole === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.fragole")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"mirtilli"}
                                                  checked={this.state.fattoriRischio.mirtilli === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.mirtilli")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"lamponi"}
                                                  checked={this.state.fattoriRischio.lamponi === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.lamponi")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"ribes"}
                                                  checked={this.state.fattoriRischio.ribes === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.ribes")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <CheckBox id={"misti"}
                                                  checked={this.state.fattoriRischio.misti === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.misti")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-1"}>
                                        <CheckBox id={"altraFruttiBosco"}
                                                  checked={this.state.fattoriRischio.altraFruttiBosco === "true"}
                                                  text={t("SchedaSpecialeEpatiteE.FattoriRischio.altraFruttiBosco")}
                                                  onChange={this.riceviValoreInput}
                                                  newCheckbox={true}
                                                  fontColor={"#1b7ea9"}
                                                  fontSize={"16px"}
                                        />
                                    </div>
                                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                        <Input
                                            type={"textarea"}
                                            id={"altraFruttoBoscoTesto"}
                                            onChange={this.riceviValoreInput}
                                            field={"altraFruttoBoscoTesto"}
                                            value={this.state.fattoriRischio.altraFruttoBoscoTesto}
                                            placeholder={"Altro frutto di bosco"}
                                            style={{display: this.state.fattoriRischio.altraFruttiBosco === "true" ? "" : "none"}}
                                        />
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div className={"row"} style={{alignItems: "center"}}>
                        <div className={"col-lg-7"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.verduraNonLavata")}
                            </p>
                            <div className={"row"}>
                                <div className={"col-lg-1"}>
                                    <RadioButton id={"verduraNonLavataSi"}
                                                 name={"verduraNonLavata"}
                                                 label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                 value={"01"}
                                                 newRadio={true}
                                                 onClick={this.riceviValoreInput}
                                                 checked={this.state.fattoriRischio.verduraNonLavata === "01"}
                                    />
                                </div>
                                <div className={"col-lg-1"}>
                                    <RadioButton id={"verduraNonLavataNo"}
                                                 name={"verduraNonLavata"}
                                                 label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                 value={"02"}
                                                 newRadio={true}
                                                 onClick={this.riceviValoreInput}
                                                 checked={this.state.fattoriRischio.verduraNonLavata === "02"}
                                    />
                                </div>
                                <div className={"col-lg-2"}>
                                    <RadioButton id={"verduraNonLavataNonSo"}
                                                 name={"verduraNonLavata"}
                                                 label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                 value={"03"}
                                                 newRadio={true}
                                                 onClick={this.riceviValoreInput}
                                                 checked={this.state.fattoriRischio.verduraNonLavata === "03"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.specificare")}
                            </p>
                            <Input
                                type={"textarea"}
                                id={"verduraSpecifica"}
                                onChange={this.riceviValoreInput}
                                field={"verduraSpecifica"}
                                value={this.state.fattoriRischio.verduraSpecifica}
                                placeholder={"Verdura"}
                                disabled={this.state.fattoriRischio.verduraNonLavata !== "01"}

                            />
                        </div>
                    </div>

                    <div className={"row"} style={{alignItems: "center"}}>
                        <div className={"col-lg-4"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.carneMaiale")}
                            </p>
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"carneMaialeSi"}
                                         name={"carneMaiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                         value={"01"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.carneMaiale === "01"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"carneMaialeNo"}
                                         name={"carneMaiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                         value={"02"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.carneMaiale === "02"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"carneMaialeNonSo"}
                                         name={"carneMaiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                         value={"03"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.carneMaiale === "03"}
                            />
                        </div>
                    </div>

                    <div className={"row"} style={{alignItems: "center"}}>
                        <div className={"col-lg-4"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.insaccati")}
                            </p>
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"insaccatiSi"}
                                         name={"insaccati"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                         value={"01"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.insaccati === "01"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"insaccatiNo"}
                                         name={"insaccati"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                         value={"02"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.insaccati === "02"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"insaccatiNonSo"}
                                         name={"insaccati"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                         value={"03"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.insaccati === "03"}
                            />
                        </div>
                    </div>

                    <div className={"row"} style={{alignItems: "center"}}>
                        <div className={"col-lg-4"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.salsicceMaiale")}
                            </p>
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"salsicceMaialeSi"}
                                         name={"salsicceMaiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                         value={"01"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.salsicceMaiale === "01"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"salsicceMaialeNo"}
                                         name={"salsicceMaiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                         value={"02"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.salsicceMaiale === "02"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"salsicceMaialeNonSo"}
                                         name={"salsicceMaiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                         value={"03"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.salsicceMaiale === "03"}
                            />
                        </div>
                    </div>

                    <div className={"row"} style={{alignItems: "center"}}>
                        <div className={"col-lg-4"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.carneCinghiale")}
                            </p>
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"carneCinghialeSi"}
                                         name={"carneCinghiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                         value={"01"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.carneCinghiale === "01"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"carneCinghialeNo"}
                                         name={"carneCinghiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                         value={"02"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.carneCinghiale === "02"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"carneCinghialeNonSo"}
                                         name={"carneCinghiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                         value={"03"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.carneCinghiale === "03"}
                            />
                        </div>
                    </div>

                    <div className={"row"} style={{alignItems: "center"}}>
                        <div className={"col-lg-4"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.salsicceCinghiale")}
                            </p>
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"salsicceCinghialeSi"}
                                         name={"salsicceCinghiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                         value={"01"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.salsicceCinghiale === "01"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"salsicceCinghialeNo"}
                                         name={"salsicceCinghiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                         value={"02"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.salsicceCinghiale === "02"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"salsicceCinghialeNonSo"}
                                         name={"salsicceCinghiale"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                         value={"03"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.salsicceCinghiale === "03"}
                            />
                        </div>
                    </div>

                    <div className={"row"} style={{alignItems: "center"}}>
                        <div className={"col-lg-7"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.selvaggina")}
                            </p>
                            <div className={"row"}>
                                <div className={"col-lg-1"}>
                                    <RadioButton id={"selvagginaSi"}
                                                 name={"selvaggina"}
                                                 label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                 value={"01"}
                                                 newRadio={true}
                                                 onClick={this.riceviValoreInput}
                                                 checked={this.state.fattoriRischio.selvaggina === "01"}
                                    />
                                </div>
                                <div className={"col-lg-1"}>
                                    <RadioButton id={"selvagginaNo"}
                                                 name={"selvaggina"}
                                                 label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                 value={"02"}
                                                 newRadio={true}
                                                 onClick={this.riceviValoreInput}
                                                 checked={this.state.fattoriRischio.selvaggina === "02"}
                                    />
                                </div>
                                <div className={"col-lg-2"}>
                                    <RadioButton id={"selvagginaNonSo"}
                                                 name={"selvaggina"}
                                                 label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                 value={"03"}
                                                 newRadio={true}
                                                 onClick={this.riceviValoreInput}
                                                 checked={this.state.fattoriRischio.selvaggina === "03"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.specificareAnimale")}
                            </p>
                            <Input
                                type={"textarea"}
                                id={"selvagginaSpecifica"}
                                onChange={this.riceviValoreInput}
                                field={"selvagginaSpecifica"}
                                value={this.state.fattoriRischio.selvagginaSpecifica}
                                disabled={this.state.fattoriRischio.selvaggina !== "01"}
                                placeholder={"Selvaggina"}
                            />
                        </div>
                    </div>

                    <div className={"row"} style={{alignItems: "center"}}>
                        <div className={"col-lg-7"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.carneAltroAnimale")}
                            </p>
                            <div className={"row"}>
                                <div className={"col-lg-1"}>
                                    <RadioButton id={"carneAltroAnimaleSi"}
                                                 name={"carneAltroAnimale"}
                                                 label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                 value={"01"}
                                                 newRadio={true}
                                                 onClick={this.riceviValoreInput}
                                                 checked={this.state.fattoriRischio.carneAltroAnimale === "01"}
                                    />
                                </div>
                                <div className={"col-lg-1"}>
                                    <RadioButton id={"carneAltroAnimaleNo"}
                                                 name={"carneAltroAnimale"}
                                                 label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                 value={"02"}
                                                 newRadio={true}
                                                 onClick={this.riceviValoreInput}
                                                 checked={this.state.fattoriRischio.carneAltroAnimale === "02"}
                                    />
                                </div>
                                <div className={"col-lg-2"}>
                                    <RadioButton id={"carneAltroAnimaleNonSo"}
                                                 name={"carneAltroAnimale"}
                                                 label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                 value={"03"}
                                                 newRadio={true}
                                                 onClick={this.riceviValoreInput}
                                                 checked={this.state.fattoriRischio.carneAltroAnimale === "03"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.specificareAnimale")}
                            </p>
                            <Input
                                type={"textarea"}
                                id={"altroAnimaleSpecifico"}
                                onChange={this.riceviValoreInput}
                                field={"altroAnimaleSpecifico"}
                                value={this.state.fattoriRischio.altroAnimaleSpecifico}
                                placeholder={"Animale"}
                                disabled={this.state.fattoriRischio.carneAltroAnimale !== "01"}
                            />
                        </div>
                    </div>

                    <div className={"row"} style={{alignItems: "center"}}>
                        <div className={"col-lg-4"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeEpatiteE.FattoriRischio.frattaglie")}
                            </p>
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"frattaglieSi"}
                                         name={"frattaglie"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                         value={"01"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.frattaglie === "01"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"frattaglieNo"}
                                         name={"frattaglie"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                         value={"02"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.frattaglie === "02"}
                            />
                        </div>
                        <div className={"col-lg-2"}>
                            <RadioButton id={"frattaglieNonSo"}
                                         name={"frattaglie"}
                                         label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                         value={"03"}
                                         newRadio={true}
                                         onClick={this.riceviValoreInput}
                                         checked={this.state.fattoriRischio.frattaglie === "03"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation('common')(FattoriRischio)
